import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black py-8 px-4 border-t border-zinc-900" data-id="element-42">
      <div className="max-w-4xl mx-auto text-center" data-id="element-43">
        <p className="font-['Crimson_Text'] text-base md:text-lg text-zinc-500 leading-relaxed" data-id="element-44">
          Descarga inmediata tras el pago. Optimizado para lectura en móviles y
          tablets.
        </p>
      </div>

      {/* Meta Pixel — noscript tracking image */}
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1673165833732305&ev=PageView&noscript=1" alt="" data-id="element-45" />
    </footer>;
}